import { clearSimFlags } from './types';

/**
 * Mesma limpeza do botão "Sair / Bloquear simulação" (cadeado):
 * tokens, perfil, flags do wizard, cookies de sessão no backend.
 * Depois redireciona com hard navigation (evita loop React).
 */
export async function sairDaSimulacao(redirectTo: '/simulador' | '/login' = '/simulador'): Promise<void> {
  try {
    localStorage.removeItem('ac_token');
    localStorage.removeItem('ac_user');
    localStorage.removeItem('ac_escolaId');
    localStorage.removeItem('ac_nomeEscola');
    localStorage.removeItem('ac_perfil');
    localStorage.removeItem('ac_cargo');
    localStorage.removeItem('ac_sessions');
    localStorage.removeItem('ac_desktop_layout');
    sessionStorage.removeItem('ac_auth_method');
    sessionStorage.removeItem('ac_logged_out');
  } catch {
    // noop
  }

  try {
    clearSimFlags();
  } catch {
    // noop
  }

  try {
    await fetch('/api/v1/auth/logout', { method: 'POST', credentials: 'include' });
  } catch {
    // noop
  }

  window.location.href = redirectTo;
}
